// App version shown in the sidebar next to the title.
// Keep in step with "version" in package.json (CRA cannot import files outside src/).
// REACT_APP_VERSION, if set at build time, wins.
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.1.01'
